import ContentRow from './content-row'

export default ContentRow;